export const toastEnterDurationMs = 300;
const exitDelayFactor = 0.35;
export const toastExitDelayMs = toastEnterDurationMs * exitDelayFactor;
export const toastExitDurationMs = toastExitDelayMs + toastEnterDurationMs;
